<template>
  <d-modal
    class="crm-new-popup institution-prices"
    v-if="showModal"
    style="background-color: rgba(0,0,0,0.6)!important; width: 110%; margin-left: -5%">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template>Potwierdzenie płatności</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-row
        no-gutters
        class="page-header py-4">
        <d-col
          col
          sm="6"
          class="text-center text-sm-left mb-4 mb-sm-0">
          <h3 class="page-title">Lista wpłat</h3>
          <p
            style="font-size: 1.5rem"
            class="text-success font-weight-light mt-1">{{customer.name}}</p>
        </d-col>
      </d-row>
      <d-card style="width: 100%;">
        <table class="table mt-0 mb-0 full-width">
          <thead class="bg-light">
            <tr>
              <th
                scope="col"
                class="border-0">Data zamówienia</th>
              <th
                scope="col"
                class="border-0">Sklep</th>
              <th
                scope="col"
                class="border-0">Kwota</th>
              <th
                scope="col"
                class="border-0">Wpłata</th>
              <th
                scope="col"
                class="border-0">Do zapłaty</th>
              <th
                scope="col"
                class="border-0">Zamówienie</th>
            </tr>
          </thead>
          <tbody v-if="dataValue">
            <tr
              v-for="(value, index) of dataValue"
              :key="'confirm-' + index">
              <td class="align-middle">
                {{ value.order_delivery_date }}
              </td>
              <td class="align-middle">
                {{ value.order_shop_name}}
              </td>
              <td class="align-middle">
                {{ value.order_price.toFixed(2) }} zł
              </td>
              <td :class="value.dept !== 0 ? 'align-middle text-danger' : 'align-middle text-success'">
                {{ value.amount.toFixed(2) }} zł
              </td>
              <td :class="value.dept !== 0 ? 'align-middle text-danger' : 'align-middle text-success'">
                {{ value.dept}} zł
              </td>
              <td
                class="align-middle"
                style="width: 15rem">
                <d-button
                  outline
                  theme="primary"
                  @click.native="$router.push('/zamowienia/edycja/' + value.order_id);closeModal();"
                  title="Przejdź do zamówienia">
                  <i class="material-icons">edit</i>
                  Przejdź do zamówienia
                </d-button>
              </td>
            <tr v-if="dataValue.length === 0">
              <td
                colspan="6"
                class="text-center">
                Brak wyników do wyświetlenia&hellip;
              </td>
            </tr>
          </tbody>
        </table>

        <div
          v-if="!dataValue"
          class="pb-3 pt-3 text-center">
          Trwa ładowanie danych&hellip;
        </div>
      </d-card>

      <div class="popup-box-buttons pb-3 pt-5">
        <d-button
          theme="success"
          class="text-nowrap"
          @click.prevent="closeModal">
          Zamknij listę
        </d-button>
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'orders-form-payment-confirm',
  data () {
    return {};
  },
  props: {
    dataValue: {
      type: [Array, Object, Boolean],
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    customer: {
      type: [Array, Object],
      required: true
    }
  },
};
</script>

<style lang="scss" scoped>
  .popup-box-buttons {
    justify-content: center;
    button {
      width: 50%;
    }
  }
</style>
